import React from 'react'
import { Box, WaitTillLoaded } from '@plvs/respawn/features/layout'
import { NxTypography } from '@playvs-inc/nexus-components'
import { makeStyles, useTheme } from '@material-ui/core'
import { useMatchOverlay } from '@plvs/respawn/features/overlay/useMatchOverlay'
import { Hotstreak } from '@plvs/respawn/features/overlay/matchOverlay/components/Hotstreak'
import { ScoreOverlayTeamCluster } from '@plvs/respawn/features/overlay/scoreOverlay/components/ScoreOverlayTeamCluster'

const useStyles = makeStyles({
  score: {
    fontSize: '4rem',
  },
})

export const ScoreOverlay: React.FC = () => {
  const styles = useStyles()
  const theme = useTheme()

  const {
    slot,
    league,
    metaseason,
    homeTeam,
    awayTeam,
    team1Score,
    team2Score,
    loading,
  } = useMatchOverlay()

  return (
    <WaitTillLoaded loading={loading}>
      <Box>
        <Box
          display="flex"
          flex={1}
          gridGap={theme.spacing(3)}
          justifyContent="space-between"
          padding={theme.spacing(2)}
        >
          <Box
            alignItems="center"
            display="flex"
            flex={1}
            gridGap={theme.spacing(3)}
            justifyContent="center"
            textAlign="center"
          >
            <ScoreOverlayTeamCluster
              avatarPosition="right"
              bgColor={theme.palette.ColorBackgroundInfo}
              team={homeTeam}
            />

            <Box display="flex" gridGap={theme.spacing(2)}>
              <Box
                alignItems="center"
                bgcolor={theme.palette.ColorBackgroundAlt}
                borderColor={theme.palette.common.black}
                borderRadius="100%"
                height={100}
                p={2}
                textAlign="center"
                width={100}
              >
                <NxTypography className={styles.score} variant="display">
                  {team1Score}
                  <Hotstreak streakLength={0} />
                </NxTypography>
              </Box>

              <Box
                alignItems="center"
                bgcolor={theme.palette.ColorBackgroundAlt}
                borderColor={theme.palette.common.black}
                borderRadius="100%"
                height={100}
                p={2}
                textAlign="center"
                width={100}
              >
                <NxTypography className={styles.score} variant="display">
                  {team2Score}
                  <Hotstreak streakLength={1000} />
                </NxTypography>
              </Box>
            </Box>

            <ScoreOverlayTeamCluster
              avatarPosition="left"
              bgColor={theme.palette.ColorBackgroundError}
              team={awayTeam}
            />
          </Box>
        </Box>

        <Box
          bgcolor={theme.palette.ColorBackgroundWarn}
          borderColor={theme.palette.common.black}
          borderRadius={theme.mixins.cornerRadius['border-radius-8']}
          mr={1}
          mt={1}
          p={1}
          position="absolute"
          right={0}
          textAlign="center"
          top={0}
        >
          <NxTypography variant="h4">{league?.name}</NxTypography>
          <NxTypography variant="h4">
            {metaseason?.name} - {slot?.name}
          </NxTypography>
        </Box>
      </Box>
    </WaitTillLoaded>
  )
}
